// extracted by mini-css-extract-plugin
module.exports = {"fields-container":"_7oosS","discount-form":"_0coMH","discount":"RR5FU","input":"M7vQr","apply":"j0fKl","error":"rYC6d"};